import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';

function ImageCarousel({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(goToNext, 7000);
    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  return (
    <div className='carousel-container'>
      <button onClick={goToPrevious} className='carousel-button prev'>&#10094;</button>

      <div className='carousel-track-container'>
        <div
          className='carousel-track'
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Slide ${index + 1}`}
              className='carousel-image'
            />
          ))}
        </div>
      </div>

      <button onClick={goToNext} className='carousel-button next'>&#10095;</button>

      {/* Dots */}
      <div className='carousel-dots'>
        {images.map((_, index) => (
          <span
            key={index}
            className={`carousel-dot${index === currentIndex ? ' active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default ImageCarousel;
